export const AddressMixin = defineNuxtComponent({
  data() {
    return {
      isAnotherAddress: false,
    };
  },

  methods: {
    getAddress(value) {
      let Address1;
      if (value.addressPostCode.number) {
        Address1 = value.addressPostCode.number;
      } else if (value.addressPostCode.addressline1) {
        Address1 = value.addressPostCode.addressline1;
      } else {
        Address1 = value.addressPostCode.buildingname;
      }
      if (value.addressPostCode.addressline1.search('Flat') !== -1) {
        Address1 = `${Address1}  ${value.addressPostCode.addressline1}`;
      }
      const fullAddress = {
        address_1: Address1 || '',
        address_2: value.addressPostCode.street || '',
        address_3: value.addressPostCode.dependentlocality || '',
        address_4: value.addressPostCode.posttown || '',
        address_5: value.addressPostCode.county || '',
        postcode: value.addressPostCode.postcode || '',
        display_name: value.addressPostCode.summaryline || '',
        country_id: 1,
      };
      if (
        value.addressGoogle &&
        value.addressGoogle.geometry &&
        value.addressGoogle.geometry.location &&
        value.addressGoogle.geometry.location.lng
      ) {
        fullAddress.long = value.addressGoogle.geometry.location.lng;
      }
      if (
        value.addressGoogle &&
        value.addressGoogle.geometry &&
        value.addressGoogle.geometry.location &&
        value.addressGoogle.geometry.location.lat
      ) {
        fullAddress.lat = value.addressGoogle.geometry.location.lat;
      }
      this.saveAddress(fullAddress);
    },

    addressReturner(value) {
      let Address1;
      if (value.addressPostCode.number) {
        Address1 = value.addressPostCode.number;
      } else if (value.addressPostCode.addressline1) {
        Address1 = value.addressPostCode.addressline1;
      } else {
        Address1 = value.addressPostCode.buildingname;
      }
      if (value.addressPostCode.addressline1.search('Flat') !== -1) {
        Address1 = `${Address1}  ${value.addressPostCode.addressline1}`;
      }
      const fullAddress = {
        address_1: Address1 || '',
        address_2: value.addressPostCode.street || '',
        address_3: value.addressPostCode.dependentlocality || '',
        address_4: value.addressPostCode.posttown || '',
        address_5: value.addressPostCode.county || '',
        postcode: value.addressPostCode.postcode || '',
        display_name: value.addressPostCode.summaryline || '',
        country_id: 1,
      };
      if (
        value.addressGoogle &&
        value.addressGoogle.geometry &&
        value.addressGoogle.geometry.location &&
        value.addressGoogle.geometry.location.lng
      ) {
        fullAddress.long = value.addressGoogle.geometry.location.lng;
      }
      if (
        value.addressGoogle &&
        value.addressGoogle.geometry &&
        value.addressGoogle.geometry.location &&
        value.addressGoogle.geometry.location.lat
      ) {
        fullAddress.lat = value.addressGoogle.geometry.location.lat;
      }

      return fullAddress;
    },

    saveAddress(fullAddress) {
      this.childModelValue = { ...fullAddress };
    },

    onAddressChangedManually(e) {
      this.saveAddress(e);
    },
  },
});
